import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { BaseComponent } from 'src/app/moov-common/base/base.component';

@Component({
  selector: 'app-chat-user-prompt',
  templateUrl: './chat-user-prompt.component.html',
  styleUrl: './chat-user-prompt.component.scss'
})
export class ChatUserPromptComponent extends BaseComponent{
  @Input() presentForceUseCases : boolean = false;
  @Output() submitUserEntryEvent = new EventEmitter<string>();
  @Output() userForcedUseCasePresentation = new EventEmitter();
  @ViewChild('userPromptArea') userPromptArea: ElementRef<HTMLInputElement>;
  
  userText : string= '';

  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  submitUserEntry(): void{
    this.submitUserEntryEvent.emit(this.userText);
    this.userText = "";
  }

  handleEnter(event : Event) {
    if(!this.userText || this.userText === '') return;
    if (event instanceof KeyboardEvent) {
      event.preventDefault();  // Prevent default Enter key action
      this.submitUserEntry();
    }
  }

  ngAfterViewInit(){
    setTimeout(() => {
      this.focusOnInput();
    }, 0); 
  }

  focusOnInput() {
    this.userPromptArea.nativeElement.focus();
  }

  forceUseCasesPresentation(): void{
    this.userForcedUseCasePresentation.emit();
  }
}
